import React from 'react';
import MDSpinner from 'react-md-spinner';
import ReactJson from 'react-json-view';

const WebUserResultItem = ({item, index, total}) => {
  const isNewFormat = item && item.user !== undefined;
  const user = isNewFormat ? item.user : item;
  const attributionData = isNewFormat ? item.attributionData : null;

  return (
    <div style={{marginBottom: '30px', borderBottom: total > 1 ? '2px solid #eee' : 'none', paddingBottom: '20px'}}>
      {total > 1 && (
        <div style={{fontWeight: '600', fontSize: '14px', color: '#888', paddingBottom: '8px'}}>
          #{index + 1}
        </div>
      )}
      <div className={'debug-info-container'}>
        <ReactJson src={user} displayDataTypes={false}/>
      </div>
      <div style={{paddingTop: '20px'}}>
        <div className={'debug-section-title'} style={{paddingBottom: '10px'}}>Web Attribution</div>
        <div className={'debug-info-container'}>
          {attributionData
            ? <ReactJson src={attributionData} displayDataTypes={false}/>
            : <span style={{color: '#aaa', fontStyle: 'italic'}}>No attribution data</span>
          }
        </div>
      </div>
    </div>
  );
};

export const DebugWebUserView = ({webUsers, isLoadingWebUsers}) => {
  return <div style={{display: 'flex', flexDirection: 'column', paddingTop: '30px'}}>
    <div className={'debug-section-title'} style={{paddingBottom: '10px'}}>Web User</div>
    {
      isLoadingWebUsers
        ? <div className='spinner-container' style={{width: '100%'}}>
            <MDSpinner size={60} singleColor={'#00DADA'}/>
          </div>
        : Array.isArray(webUsers) && webUsers.length > 0
          ? webUsers.map((item, index) => (
              <WebUserResultItem key={index} item={item} index={index} total={webUsers.length}/>
            ))
          : <div className={'debug-info-container'}>
              <ReactJson src={webUsers} displayDataTypes={false}/>
            </div>
    }
  </div>;
};